<template>
    <div>
        <el-dialog title="新增" v-model="editFormVisible" :visible.sync="editFormVisible" :close-on-click-modal="false">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <el-form-item label="角色名称">
                    <el-input v-model="form.FName"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="form.FNote"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="save" :loading="loading">保存</el-button>
            </div>
      </el-dialog>
    </div>
</template>

<script>
    import util from '../../common/util'
    export default {
        data() {
            return {
                form: {},
                rules: {
                    FName: [{required: true,message: '家庭名称', trigger: 'change'}]
                },
                loading:false,
                editFormVisible:false
            }
        },
        methods: {
            switchLoading(flag){
                this.loading = flag;
            },
            _openEdit(record) {
                this.editFormVisible = true;
                this.form = Object.assign({},record);
            },
            _openAdd(record) {
                this.editFormVisible = true;
                this.form = Object.assign({FID:0},record);
            },
            save:function () {
                util.post("server/system/Role.ashx?cmd=SaveRole",this.form,this.switchLoading,result=> {
                    util.msgSuc("保存成功")
                    this.editFormVisible = false
                    this.$emit("onSaveSuc",this.form)
                })
            }
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/system/Role_Edit.vue